import { Result } from "appworks/model/gameplay/records/results/result";

export class SlingoJokerResult extends Result {
    public resultType: string = "SlingoJokerResult";

    public jokerCells: number[];
    public superJokerCells: number[];
}
